import React, { useContext } from 'react'

import { PositionedColorTag, StyledInnerElement } from 'components/Tree/nodes/common'
import { RestaurantContext } from '../RestaurantDesignerHandler'

import { ReactComponent as Middle } from 'components/Tree/icons/middle.svg'
import { ReactComponent as Bottom } from 'components/Tree/icons/bottom.svg'


const Room = ({ label, isSelected, isSelectable, isLastChild, handleSelect, floorId, id }) => {
	const { currentProjectIds } = useContext(RestaurantContext)
	let isActive = false
	if(isSelected && (currentProjectIds.floorId === floorId && currentProjectIds.roomId === id)) {
		isActive = true
	} else if (currentProjectIds.floorId === floorId && currentProjectIds.roomId === id) {
		isActive = true
	}
	return(
		<li>
			<StyledInnerElement onClick={handleSelect} paddingLeft={48} isSelectable={isSelectable} noBorder noBackground>
				{(isSelectable) && <PositionedColorTag color={isActive ? '#3c4e5a' : null}/>}
				{isLastChild ?
					<Bottom style={{ marginBottom: 'auto', marginRight: '5px' }}/> :
					<Middle style={{ marginRight: '5px' }}/>
				}
				{label}
			</StyledInnerElement>
		</li>
	)
}

export default Room
